module.exports = __webpack_public_path__ + "static/media/16UNODC29.36cd6c9a.jpg";